import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=ad6af0aa"
import script from "../script/dashboard-script.js?vue&type=script&lang=js&external"
export * from "../script/dashboard-script.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports